import type { AsyncOptions } from './types';

export const resolveAsyncOptions = async <T>(
  options: AsyncOptions<T>,
): Promise<T> => {
  if (typeof options === 'function') {
    return await options();
  }
  return Promise.resolve(options);
};
